import { cnpj, cpf } from 'cpf-cnpj-validator';
import moment from 'moment';
import * as yup from 'yup';

import { userExists } from '../../services/user';
import { cpfExists } from '../../services/user';

yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    // eslint-disable-next-line no-template-curly-in-string
    min: 'O campo deve ter no mínimo ${min} caracteres',
  }
});

let emailsValidated = {};
let cpfsValidated = {};
export const clearCpfsValidated = () => {
  cpfsValidated = {};
};

export const clearEmailsValidated = () => emailsValidated = {};

const registerSchemaCnpj = yup.object().shape({
  email: yup
    .string()
    .required()
    .email('E-mail inválido')
    .test('is-already-email-exists', 'Email já existe', async (value) => {
      if (!(await yup.string().email().isValid(value)) || !value) {
        return true;
      }
      if (emailsValidated[value] === undefined) {
        try {
          await userExists({ email: value });
          emailsValidated[value] = false;
        } catch (err) {
          emailsValidated[value] = true;
        }
      }

      return emailsValidated[value];
    }),
  document: yup
    .string()
    .required()
    .test('is-valid-document',
      'CPF/CNPJ já esta em uso', async (value) => {
        console.log(value);
        if (!(cpf.isValid(value) || cnpj.isValid(value)) || !value) {
          return true;
        }

        if (cpfsValidated[value] === undefined) {
          try {
            await cpfExists({ cpf: value });
            cpfsValidated[value] = false;
          } catch (err) {
            cpfsValidated[value] = true;
          }
        }

        return cpfsValidated[value];
      }),
  document_state: yup.string(),
  name: yup.string().required(),
  fantasy_name: yup.string().required(),
  password: yup
    .string()
    .required()
    .min(8)
    .test(
      'strong-password',
      'A senha não atende aos parâmetros de segurança',
      (value) => {
        if (!value) {
          return false;
        }
        if (
          value.match(/[0-9]+/g) &&
          value.match(/[A-Z]+/g) &&
          value.match(/[a-z]+/g)
        ) {
          return true;
        }

        return false;
      }
    ),
  password_confirmation: yup
    .string()
    .required()
    .oneOf([yup.ref('password'), null], 'Senhas não conferem'),
  date_foundation: yup
    .string()
    .required()
    .test(
      'past-birthdate',
      'O campo não pode ser anterior à 01/01/1800',
      (value) => {
        const momentDate = moment(value, 'DD/MM/YYYY', true);
        return momentDate.isValid() && momentDate.isAfter('1899-12-31');
      }
    )
    .test('invalid-date_foundation', 'O campo requer o formato dd/mm/aaaa', (value) =>
      moment(value, 'DD/MM/YYYY', true).isValid()
    ),
  telephone: yup.string().required(),
});

export default registerSchemaCnpj;

